import { render, staticRenderFns } from "./UserExternalCollaboration.vue?vue&type=template&id=50832420&"
import script from "./UserExternalCollaboration.vue?vue&type=script&lang=ts&"
export * from "./UserExternalCollaboration.vue?vue&type=script&lang=ts&"
import style0 from "./UserExternalCollaboration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
